export { PanResponderAdapter as Pager } from './PanResponderAdapter';
//# sourceMappingURL=Pager.js.map